/*
  MOVIQ: één tik op een kaart = direct naar de pagina (iPhone/iPad)

  Op touchapparaten volgde een tik op een product- of collectiekaart pas bij de
  tweede tik: Safari handelt de eerste tik af als 'hover' zodra er bij die tik iets
  in de kaart of carrousel verandert. Dit script vangt een korte tik op de kaart op
  en opent de link direct.

  - Alleen bij een korte tik zonder veeg- of scrollbeweging (max 10px, max 600ms).
  - Knoppen, kleurbolletjes, maatkeuze, snel-toevoegen enz. werken zoals altijd.
  - Niet actief in de thema-editor.
  Geladen vanuit layout/theme.liquid.
*/
(function () {
  if (window.__moviqCardTap) return;
  window.__moviqCardTap = true;

  var CARD = '.collection-card, product-card';
  var CARD_LINK = 'a.collection-card__link[href], a.product-card__link[href]';
  var INTERACTIVE =
    'button, input, label, select, textarea, summary, [role="button"], quick-add-component, ' +
    'swatches-variant-picker-component, product-swatches, .quick-add, dialog';

  var start = null;

  document.addEventListener(
    'touchstart',
    function (event) {
      start = null;
      if (event.touches.length !== 1) return;
      var target = event.target;
      if (!(target instanceof Element)) return;

      var card = target.closest(CARD);
      if (!card) return;
      if (target.closest(INTERACTIVE)) return;

      var touch = event.touches[0];
      start = { x: touch.clientX, y: touch.clientY, time: Date.now(), card: card };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      if (!start) return;
      var s = start;
      start = null;

      if (window.Shopify && window.Shopify.designMode) return;
      if (s.card.hasAttribute('data-no-navigation')) return;

      var touch = event.changedTouches[0];
      if (!touch) return;
      if (Math.abs(touch.clientX - s.x) > 10 || Math.abs(touch.clientY - s.y) > 10) return;
      if (Date.now() - s.time > 600) return;

      var target = event.target instanceof Element ? event.target : null;
      var tapped = target && target.closest('a[href]');
      var link = tapped && s.card.contains(tapped) ? tapped : s.card.querySelector(CARD_LINK);
      if (!link || !link.href) return;
      if (link.target === '_blank') return;

      event.preventDefault();
      window.location.href = link.href;
    },
    { passive: false }
  );

  document.addEventListener(
    'touchcancel',
    function () {
      start = null;
    },
    { passive: true }
  );
})();
